module.exports = __webpack_public_path__ + "img/logo.cbc1c735.png";